var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#DC0451",
  d: "m12.924 3.933 8.932 15.47c.41.712-.104 1.6-.924 1.6H3.069a1.067 1.067 0 0 1-.925-1.6l8.932-15.47a1.067 1.067 0 0 1 1.848 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.998 8.426h2.047v4.037q0 .65-.078 1.288-.078.64-.205 1.301h-1.481a19 19 0 0 1-.205-1.301 11 11 0 0 1-.078-1.288zm2.149 9.65a1.2 1.2 0 0 1-.265.385 1.25 1.25 0 0 1-.882.346q-.268 0-.493-.092a1.177 1.177 0 0 1-.653-.639 1.2 1.2 0 0 1-.095-.475 1.17 1.17 0 0 1 .356-.854 1.25 1.25 0 0 1 .885-.353q.262 0 .487.095.225.096.395.258a1.17 1.17 0 0 1 .36.854q0 .254-.095.476"
})));
export { SvgAlert as ReactComponent };